<template>
    <v-dialog
      v-model="isSuccessed"
      persistent
      max-width="60%"
    >
      <v-card>
         <v-card-text class="text-center">
            <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
            <p v-html="successText"></p>

            <div class="my-3 text-left">
              <v-card v-show="hasOpinion" outlined max-width="90%" class="mx-auto" color="amber lighten-5">
                <v-card-title>
                  <v-icon class="mr-1" color="red" large>mdi-information</v-icon>
                  <span class="title font-weight-light">ジャパン・アナリストよりご連絡いたします。</span>          
                </v-card-title>
                <v-card-text class="body-2 black--text">
                  お見積り内容、ご相談内容を確認させていただきます。<br>
                  <br>
                  お見積書の発行まで暫くお待ちください。<br>
                </v-card-text>
              </v-card>

              <v-card v-show="!hasOpinion" outlined max-width="90%" class="mx-auto" color="green lighten-5">
                <v-card-title>
                  <v-icon class="mr-1" color="primary" large>mdi-information</v-icon>
                  <span class="title font-weight-light">お見積書を発行しました。</span>          
                </v-card-title>
                <v-card-text class="body-2 black--text">
                  お見積書を発行しました。<br>
                  <br>
                  <b>「分析・診断サービスお見積書を印刷する」</b>をクリックして「分析・診断サービス お見積書」画面でご確認下さい。<br>
                  <br>
                  また、お見積り依頼された内容で分析依頼をお申込みいただけます。<br>
                  「分析・診断サービス お見積書」画面の<b>「お見積りの内容で申し込む」</b>からお申込み下さい。<br>
                  <br>
                  <span class="mr-1">分析・診断サービスにお申込みいただく前に</span>
                  <v-btn
                    text
                    class="align-center px-0 mx-1"
                    @click="openPrecautions()"
                  >
                    <span class="red--text">分析ご依頼時の注意事項</span>
                  </v-btn>
                  <span class="mr-1">をご確認下さい。</span>

                </v-card-text>
              </v-card>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            outlined
            @click="showDialog()"
            class="mb-5 mr-3"
          >
            お申込みページに戻る
          </v-btn>
          <v-btn
            v-show="!hasOpinion" 
            color="amber darken-1"
            rounded
            :to="{ path: '/quotesheet', query: { id: id }}"
            class="mb-5 mr-3"
          >
            <span class="px-2">
              <v-icon small>mdi-calculator</v-icon>
              分析・診断サービスお見積書を印刷
            </span>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["successUrl","successText"],
    data: () => ({
        isSuccessed: false,
        id: "",
        hasOpinion: false,
//        precautions_url: process.env.VUE_APP_PRECAUTIONS_URL,
        precautions_url: "https://www.japan-analysts.com/oilmatrix/J20-28-21-009-002_Precautions.pdf",
    }),
    methods: {
      showDialog() {
        this.isSuccessed = false
//          this.$router.back()
        this.$router.push(this.successUrl)
      },
      openPrecautions() {
        console.log("process.env", process.env)
        window.open(this.precautions_url, '_blank')
      },
      open(ifjson) {
        console.log('result from modal:', ifjson)
        this.id = ifjson.id
        this.hasOpinion = ifjson.hasOpinion
        
        this.isSuccessed = true
      }
    }
}
</script>

